export const ROLE_ARTIST = 'artist';
const ACTIVE_STATUSES = ['active', 'trialing'];

export function hasUnlockedArtistAccess(user) {
  const artistSubscription = getRoleSubscription(user, ROLE_ARTIST);
  return Boolean(
    user?.artistApprovalApproved
    || String(user?.artistId || '').trim()
    || artistSubscription?.hasEverSubscribed
    || user?.roles?.[ROLE_ARTIST]
  );
}

export function isArtistApproved(user) {
  return hasUnlockedArtistAccess(user);
}

export function getArtistApplicationStatus(user) {
  if (isArtistApproved(user)) return 'approved';
  const status = String(user?.artistApplicationStatus || '').trim().toLowerCase();
  if (['pending', 'rejected', 'approved'].includes(status)) return status;
  return 'not_started';
}

export function getRoleSubscription(user, role) {
  if (!user) return {};
  const scoped = user?.subscriptions?.[role];
  if (scoped && typeof scoped === 'object') return scoped;
  return {};
}

export function isRoleSubscriptionActive(user, role) {
  const subscription = getRoleSubscription(user, role);
  return Boolean(subscription?.isActive || ACTIVE_STATUSES.includes(String(subscription?.status || '').trim()));
}

export function hasRole(user, role) {
  return Boolean(user?.roles?.[role]);
}

export function hasRoleEntitlement(user, role) {
  const subscription = getRoleSubscription(user, role);
  if (role === ROLE_ARTIST && !isArtistApproved(user)) return false;
  return Boolean(subscription?.hasEverSubscribed || hasRole(user, role));
}

export function getRoleAccessState(user, role) {
  const subscription = getRoleSubscription(user, role);
  const approved = role === ROLE_ARTIST ? isArtistApproved(user) : true;
  const isActive = approved && isRoleSubscriptionActive(user, role);
  const hasEntitlement = hasRoleEntitlement(user, role);
  return {
    subscription,
    isApproved: approved,
    applicationStatus: role === ROLE_ARTIST ? getArtistApplicationStatus(user) : 'approved',
    isActive,
    hasEntitlement,
    isExpired: hasEntitlement && !isActive,
  };
}
